/** The standings that mean a relation is live rather than over. */
export const CURRENT_STANDINGS = [
    "current",
    "open",
    "offered",
    "proposed",
    "agreed",
    "out",
    "unanswered",
];
export function standsCurrent(standing) {
    return CURRENT_STANDINGS.includes(standing);
}
//# sourceMappingURL=counterparties.js.map